import Vue from 'vue'

import InputDate from '@/components/InputDate'
import ContactUs from '@/components/ContactUs'
import EntityForm from '@/components/EntityForm'
import AddressWithGoogleMapsImage from '@/components/AddressWithGoogleMapsImage'
import GoogleAutocomplete from '@/components/GoogleAutocomplete'
import ChangePassword from '@/components/ChangePassword'
import AddressForm from '@/components/AddressForm'
import CrudMessageResponse from '@/components/CrudMessageResponse'
import { VMoney } from "v-money";
import VueTheMask from 'vue-the-mask'

Vue.directive('money', VMoney);

Vue.component('InputDate', InputDate);
Vue.component('ContactUs', ContactUs);
Vue.component('EntityForm', EntityForm);
Vue.component('AddressWithGoogleMapsImage', AddressWithGoogleMapsImage);
Vue.component('GoogleAutocomplete', GoogleAutocomplete);
Vue.component('ChangePassword', ChangePassword)
Vue.component('AddressForm', AddressForm)
Vue.component('CrudMessageResponse', CrudMessageResponse)

Vue.use(VueTheMask)